import { Link } from 'react-router-dom';

import { styled } from '@mui/material/styles';
import theme from '../../theme';

export const LinkCustom = styled(Link)(props => ({
  textDecoration: 'none',
  color: '#fff',
  '&:visited': {
    color: '#fff'
  },
  '&:hover': {
    color: '#fff'
  }
}))

export const LinkExternalCustom = styled('a')(({ theme }) => ({
  textDecoration: 'none',
  '&:visited': {
    color: '#fff'
  },
  '&:hover': {
    color: '#fff'
  }
}))

export const LinkExternalSystem = styled('a')(({ theme }) => ({
  textDecoration: 'none',
  '&:hover': {
    color: `${theme.palette.system.main}`
  }
}))

export const LinkExternalNormal = styled('a')(({ theme }) => ({
  display: 'block',
  width: '100%',
  textDecoration: 'none',

  '&.link--align--center': {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  '&.link--white': {
    color: '#fff',
    '&:visited': {
      color: '#fff'
    },
  },

  '&.link--normal': {
    color: `${theme.palette.grey.w700}`,
    '&:visited': {
      color: `${theme.palette.grey.w700}`
    },
    '&:hover': {
      color: `${theme.palette.grey.w900}`
    },
  }
}))

export const LinkInternalNormal = styled(Link)(props => ({
  display: 'block',
  width: '100%',
  textDecoration: 'none',

  '&.nav-list': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '8px 12px',
    borderRadius: '4px',
    transition: '.5s',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
    },
    '&.active, &.active:visited': {
      [theme.breakpoints.down('lg')]: {
        color: props.mediacolor,
      },
      [theme.breakpoints.up('lg')]: {
        color: props.mediacolor,
        backgroundColor: 'rgba(0, 0, 0, 0.05)'
      }
    }
  },

  '&.link--align--center': {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },

  '&.link--white': {
    color: '#fff',
    '&:visited': {
      color: '#fff'
    },
  },

  '&.link--normal': {
    color: `${props.theme.palette.text.primary}`,
    '&:visited': {
      color: `${props.theme.palette.text.primary}`
    },
  },

  '&.mobile--spacing': {
    padding: '12px 4px'
  }
}))

export const LinkInternalPrimary = styled(Link)(props => ({
  color: props.theme.palette.primary.main,
  fontSize: 'inherit',
  transition: 'all .5s',
  '&:hover': {
    color: `${props.theme.palette.primary.w700}`
  },
}))

export const menuNormal = styled(Link)(({ theme }) => ({
  '&.menu-title': {
    fontSize: "medium",
    display: 'flex',
    alignItems: 'center',
    padding: '6px 0'
  },
  '&.menu-child': {
    fontSize: "medium",
    padding: '6px 0',
    color: `${theme.palette.text.primary}`,
    '&:visited': {
      color: `${theme.palette.text.primary}`
    },
    '&:hover': {
      color: `${theme.palette.primary.main}`
    },
  }
}))